// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Cuba from '../_raw/flag/icon_flag_cuba.png';

export default () => <img src={Cuba} alt="Cuba" />;
